// UserViewPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Row, Col, Button, Avatar, Spin, Alert, Typography } from 'antd';
import { UserOutlined, EditOutlined, LeftOutlined } from '@ant-design/icons';
import { getUserById } from '../../services/users';
import { resolveMedia } from '../../utils/media';
import '../../styles/global.css';
import usePermissions from '../../hooks/usePermissions';
const UserViewPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { Title } = Typography;
  
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);

  const { can } = usePermissions();

  useEffect(() => {
    if (!id) {
      setError('ID de usuario no proporcionado');
      setLoading(false);
      return;
    }

    const loadUser = async () => {
      try {
        setLoading(true);
        setError(null);
        const userData = await getUserById(id);
        setUser(userData);
      } catch (err) {
        console.error('Error al cargar usuario:', err);
        setError('No se pudo cargar la información del usuario');
      } finally {
        setLoading(false);
      }
    };

    loadUser();
  }, [id]);

  const handleEdit = () => {
    navigate(`/users/${id}/edit`);
  };

  const handleBack = () => {
    navigate('/users/all');
  };

  if (loading) {
    return (
      <div style={{ padding: 24, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          message="Error"
          description={error}
          type="error"
          showIcon
          action={
            <Button size="small" onClick={handleBack}>
              Volver
            </Button>
          }
        />
      </div>
    );
  }

  if (!user) {
    return (
      <div style={{ padding: 24 }}>
        <Alert
          message="Usuario no encontrado"
          description="El usuario solicitado no existe o no se pudo cargar."
          type="warning"
          showIcon
          action={
            <Button size="small" onClick={handleBack}>
              Volver
            </Button>
          }
        />
      </div>
    );
  }

  // Formatear teléfono si existe
  const formatPhone = (phone) => {
    if (!phone) return 'No disponible';
    // Formato: XXX-XXXX-XXX
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length === 10) {
      return `${cleaned.substring(0, 3)}-${cleaned.substring(3, 7)}-${cleaned.substring(7)}`;
    }
    return phone;
  };

  return (
    <div style={{ padding: 24, margin: '0 auto' }}>
      {/* Header */}
      <div style={{ marginBottom: 24, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Button 
            type="text" 
            icon={<LeftOutlined style={{ fontSize: '24px', strokeWidth: 4 }} />} 
            style={{ 
              padding: 0,
              color: '#BA955E',
              fontSize: '24px',
              fontWeight: '700',
              height: 'auto'
            }}
            onClick={handleBack}
          />
          <Title level={3} style={{ marginBottom: 0 }}>Detalles de usuario</Title>
        </div>

        {can('users.edit') && (<Button 
          type="text" 
          icon={<EditOutlined style={{ fontSize: '24px', strokeWidth: 4 }} />} 
          onClick={handleEdit}
          style={{ 
            padding: 0,
            color: '#262626',
            fontSize: '24px',
            fontWeight: '100',
            height: 'auto'
          }}
        />)}
      </div>

      <Card
        style={{
          borderRadius: '32px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}
      >


      <Row gutter={16}>
          <Col xs={24} md={6}>
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              alignItems: 'center',
              gap: 16 
            }}>
              <Avatar
                size={160}
                src={user.photoUrl ? resolveMedia(user.photoUrl) : null}
                icon={<UserOutlined />}
                style={{ 
                  fontSize: '48px',
                  border: '3px solid #f0f0f0'
                }}
              />
            </div>
          </Col>
          <Col xs={24} md={18}>
            <Row gutter={16}>
              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Nombre
                </div>
                <div className="field-value">
                  {user.firstName || 'No disponible'}
                </div>
              </Col>
              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Apellido Paterno
                </div>
                <div className="field-value">
                  {user.lastName || 'No disponible'}
                </div>
              </Col>
              <Col xs={24} md={8} className='col-spaced'>
                <div className="field-label">
                  Apellido Materno
                </div>
                <div className="field-value">
                  {user.secondLastName || 'No disponible'}
                </div>
              </Col>

              <Col xs={24} md={12} className='col-spaced'>
                <div className="field-label">
                  Correo Electrónico
                </div>
                <div className="field-value">
                  {user.email || 'No disponible'}
                </div>
              </Col>

              <Col xs={24} md={12} className='col-spaced'>
                <div className="field-label">
                  teléfono móvil
                </div>
                <div className="field-value">
                  {formatPhone(user.phone) || 'No disponible'}
                </div>
              </Col>

              <Col xs={24} md={12} className='col-spaced'>
                <div className="field-label">
                  Rol
                </div>
                <div className="field-value">
                  {user.role?.description || 'No disponible'}
                </div>
              </Col>
            </Row> 
          </Col>
        </Row> 


      </Card>
    </div>
  );
};

export default UserViewPage;